'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdDns = function MdDns(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm11.6 15c1.8 0 3.4-1.6 3.4-3.4s-1.6-3.2-3.4-3.2-3.2 1.4-3.2 3.2 1.4 3.4 3.2 3.4z m21.8-10c0.9 0 1.6 0.7 1.6 1.6v10c0 1-0.7 1.8-1.6 1.8h-26.8c-0.9 0-1.6-0.8-1.6-1.8v-10c0-0.9 0.7-1.6 1.6-1.6h26.8z m-21.8 26.6c1.8 0 3.4-1.4 3.4-3.2s-1.6-3.4-3.4-3.4-3.2 1.6-3.2 3.4 1.4 3.2 3.2 3.2z m21.8-10c0.9 0 1.6 0.8 1.6 1.8v10c0 0.9-0.7 1.6-1.6 1.6h-26.8c-0.9 0-1.6-0.7-1.6-1.6v-10c0-1 0.7-1.8 1.6-1.8h26.8z' })
        )
    );
};

exports.default = MdDns;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/dns.js
// module id = 3255
// module chunks = 168707334958949